// src/components/Ads1Component.jsx
import React, { useEffect, useState } from "react";
import { API_URL } from "../config";
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
} from "@mui/material";
import { motion } from "framer-motion";

const MotionCard = motion(Card);

const Ads1Component = () => {
  const [ads, setAds] = useState([]);
  const [authToken, setAuthToken] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  const isValidJson = (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    const fetchAuthToken = () => {
      try {
        const tokenString = localStorage.getItem("authToken");
        if (tokenString && isValidJson(tokenString)) {
          const token = JSON.parse(tokenString);
          setAuthToken(token.access);
        }
      } catch (error) {
        console.error("Error fetching auth token:", error);
      }
    };
    fetchAuthToken();
  }, []);

  useEffect(() => {
    const fetchAds = async () => {
      if (!authToken) return;

      try {
        const response = await fetch(`${API_URL}/ads1/`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          setAds(data);
        } else {
          console.error("Error fetching Ads:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching Ads:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAds();
  }, [authToken]);

  useEffect(() => {
    if (ads.length === 0) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % ads.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [ads]);

  return (
    <Box sx={{ mt: 4 }}>
      {loading ? (
        <Box sx={{ textAlign: "center", py: 6 }}>
          <CircularProgress color="primary" />
          <Typography variant="body2" sx={{ mt: 2, color: "text.secondary" }}>
            Loading ads…
          </Typography>
        </Box>
      ) : ads.length > 0 ? (
        <MotionCard
          key={currentIndex}
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          elevation={0}
          sx={{
            borderRadius: 4,
            overflow: "hidden",
            border: "1px solid rgba(99,102,241,0.12)",
            boxShadow: "0 8px 24px rgba(99,102,241,0.08)",
            background: "linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)",
          }}
        >
          <CardContent sx={{ p: 0 }}>
            <Box
              component="img"
              src={ads[currentIndex].adsImg}
              alt="Ad"
              sx={{
                width: "100%",
                height: 280,
                objectFit: "cover",
                borderRadius: "inherit",
              }}
            />
          </CardContent>
        </MotionCard>
      ) : (
        <Box sx={{ textAlign: "center", py: 6 }}>
          <Typography variant="body1" color="text.secondary">
            No ads available
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default Ads1Component;
